import ILanguage from './ILanguage';

const es: ILanguage = {
    title: 'Idioma',
    portuguese: 'Portugués',
    english: 'Inglés',
    spanish: 'Español',
    prev: 'previa',
    next: 'siguiente',
    send: 'Enviar',
    thankYouPageLeftTitle: 'Búsqueda de satisfacción',
    thankYouPageRightTitle: 'Gracias',
    thankYouPageText: '¡Su opinión es muy importante para nosotros!',
    loadingSplashScreenText: 'Cargando...',
    of: 'de',
    developedBy: 'Desarrollado por',
    requiredField: 'Campo obligatorio',
    selectionLimitHint: 'Seleccione como máximo {count} opción | Seleccione como máximo {count} opciones',
    requiredQuestionLabel: '(obligatorio)',
    optionalQuestionLabel: '(opcional)',
    staticClassForSandbox: 'Clases estáticas para entorno de prueba',
    parameterWarningLabel: 'Agregar nombre y valor del parámetro al final de la URL como "&<name>=<valor>".',
    AutoCompleteLoadingText: 'Cargando por favor espere',
    AutoCompleteNoOptionsText: 'No hay opción disponible',
    AutoCompleteNoResultsText: 'Ningún resultado encontrado',
    AutoCompleteRetryTitle: 'Intentar nuevamente',
    AutoCompleteSearchPromptText: 'Escriba para cargar opciones',
    environmentSandbox: 'Formulario de prueba, solo para visualización',
    alreadyCompletedForm: 'Ya has completado este formulario.',
    formUnavailable: 'Este formulario no está disponible',
    form_unavailable_message: '¡Ups! Evaluación no disponible en este momento',
    form_unavailable_description: 'Esta evaluación ya no está disponible en este momento.',
    expired_survey_message: '¡Ups! Evaluación expirada',
    expired_survey_description: 'El período para realizar esta evaluación ha expirado.',
    form_already_answered_message: 'Esta evaluación ya ha sido realizada',
    form_already_answered_description: 'No es posible realizar esta evaluación nuevamente.',
    like: 'Me gusta',
    dislike: 'No me gusta',
    scoreOption: 'Puntuación {score}',
    formSubmitted: 'Formulario enviado.',
};

export default es;
